export default __webpack_public_path__ + "static/media/_abkhazia.ef84bbd4.ico";